import types from '/src/store/types'
import Cookies from 'js-cookie'
import { forEach, merge, reduce } from 'lodash'
import { queryParamsRules } from './config'

export default {
  processSpecificQueryParams: ({ rootState, commit }) => new Promise((resolve) => {
    let paramsObj = {}
    let queryHasUtms = reduce(Object.keys(queryParamsRules.utms), (res, key) => {
      return res || rootState.route.query[key]
    }, false)
    if (queryHasUtms) {
      forEach(Object.keys(queryParamsRules.utms), key => {
        Cookies.remove(key)
      })
    }
    forEach(merge(queryParamsRules.other, queryParamsRules.utms), (param, key) => {
      if (Cookies.get(key)) {
        paramsObj[key] = Cookies.get(key)
      }
      if (rootState.route.query[key]) {
        Cookies.set(key, rootState.route.query[key], {
          expires: param.days
        })

        paramsObj[key] = rootState.route.query[key]
      }
    })
    if (document.referrer && !(document.referrer.includes(window.location.hostname))) {
      Cookies.set('document_referrer', document.referrer, {
        expires: 30
      })
    }
    commit(types.marketing.SET_SPECIFIC_QUERY_PARAMS_FULLY, paramsObj)
    resolve()
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/marketing/actions.js